export function isRequiredValidation(validations?: { type: string }[]) {
  return validations?.some(({ type }) => type === 'required');
}
